/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Api_Keys_Create_LabelInputs */

const en_options_api_keys_create_label = /** @type {(inputs: Options_Api_Keys_Create_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create new API key`)
};

const fr_options_api_keys_create_label = /** @type {(inputs: Options_Api_Keys_Create_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créer une nouvelle clé API`)
};

const de_options_api_keys_create_label = /** @type {(inputs: Options_Api_Keys_Create_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neuen API-Schlüssel erstellen`)
};

const it_options_api_keys_create_label = /** @type {(inputs: Options_Api_Keys_Create_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea una nuova chiave API`)
};

const ru_options_api_keys_create_label = /** @type {(inputs: Options_Api_Keys_Create_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Создать новый ключ API`)
};

const es_options_api_keys_create_label = /** @type {(inputs: Options_Api_Keys_Create_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crear nueva clave API`)
};

const zh_cn2_options_api_keys_create_label = /** @type {(inputs: Options_Api_Keys_Create_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建新的 API 密钥`)
};

const ja_options_api_keys_create_label = /** @type {(inputs: Options_Api_Keys_Create_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しいAPIキーを作成する`)
};

const hi_options_api_keys_create_label = /** @type {(inputs: Options_Api_Keys_Create_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नई एपीआई कुंजी बनाएं`)
};

const pt_pt2_options_api_keys_create_label = /** @type {(inputs: Options_Api_Keys_Create_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criar nova chave de API`)
};

/**
* | output |
* | --- |
* | "Create new API key" |
*
* @param {Options_Api_Keys_Create_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_api_keys_create_label = /** @type {((inputs?: Options_Api_Keys_Create_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Api_Keys_Create_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_api_keys_create_label(inputs)
	if (locale === "de") return de_options_api_keys_create_label(inputs)
	if (locale === "it") return it_options_api_keys_create_label(inputs)
	if (locale === "ru") return ru_options_api_keys_create_label(inputs)
	if (locale === "es") return es_options_api_keys_create_label(inputs)
	if (locale === "zh-CN") return zh_cn2_options_api_keys_create_label(inputs)
	if (locale === "ja") return ja_options_api_keys_create_label(inputs)
	if (locale === "hi") return hi_options_api_keys_create_label(inputs)
	if (locale === "pt-PT") return pt_pt2_options_api_keys_create_label(inputs)
	return en_options_api_keys_create_label(inputs)
});